export default {
    worktime_main_url: 'https://app.tweem.com',
    worktime_service_url:'https://api.tweem.com/worktime-service/rest/',
    magnolia_base_url: 'https://tweem.com',
    magnolia_service_url: 'https://cors-anywhere.vbote.com/https://tweem.com/.rest/',
    superset_base_url: 'https://superset.vbote.com',
    socketio_channel_url: 'https://channel.tweem.com',
    tweem_environment: 'prod'
};
